import React from "react";
import PropTypes from "prop-types";

const Image = ({ src, alt, height, width, className }) => (
  <img
    className={className}
    src={src}
    alt={alt}
    height={height}
    width={width}
  />
);

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
};

export default Image;
